import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

export const DeactivatedIcon = ({text, isBold}) => {
	return <StyledIcon isBold={isBold}>{text}</StyledIcon>;
};

DeactivatedIcon.propTypes = {
	text: PropTypes.string,
	isBold: PropTypes.bool,
};

export const StyledIcon = Styled.div`
	font-size: 11px;
	border: 1px solid ${CSS_CONSTANTS.v2_button_very_light_grey};
	border-radius: 11px;
	padding: 4px 8px;
	${props => (props.isBold ? 'font-weight: 500;' : 'font-weight: 400;')}
	align-self: center;
    color: ${CSS_CONSTANTS.v2_text_gray};
    margin-left: 8px;
`;
